// Utilities to extract human-friendly messages from API errors/rejection reasons
export function getErrorMessage(err) {
  try {
    if (!err) return "Internal Server Error";
    // axios-style error
    if (err.response && err.response.data) {
      const d = err.response.data;
      if (typeof d === "string") return d;
      if (d.message) return d.message;
      if (d.error) return d.error;
      // sometimes backend returns nested objects
      return JSON.stringify(d);
    }
    // plain Error
    if (err.message) return err.message;
    // settled Promise rejection reason could be a string
    if (typeof err === "string") return err;
    // fallback
    return String(err);
  } catch (e) {
    return "Internal Server Error";
  }
}

// Convenience: attempt to notify using a provided notifier, falling back to
// `window.callSnackbar` or the page-local `se-snackbar#snackbar-custom-1`.
export function notifyError(err, notifier) {
  const msg = getErrorMessage(err);
  try {
    if (typeof notifier === "function") {
      notifier("error", msg);
      return;
    }
    if (typeof window !== "undefined" && typeof window.callSnackbar === "function") {
      window.callSnackbar("error", msg, { duration: 8000 });
      return;
    }
    // fallback to DOM-manipulation of the local snackbar element if present
    const el = typeof document !== "undefined" && document.getElementById("snackbar-custom-1");
    if (el) {
      try { el.setAttribute("type", "error"); } catch (e) {}
      try { el.setAttribute("message", msg); } catch (e) {}
      try { el.setAttribute("can-close", "true"); } catch (e) {}
      try { el.open = true; } catch (e) {}
      try { el.setAttribute("open", ""); } catch (e) {}
    }
  } catch (e) {
    // swallow
  }
}

export default { getErrorMessage, notifyError };
